import { useMemo } from 'react';
import useRouteBasedStepperLayout from 'components/Stepper/RouteBasedStepper/useRouteBasedStepperLayout';
import useChangeExistingPlanFlow from './useChangeExistingPlanFlow';
import { useChangePlan } from '../context';

export const useChangeExistingPlanLayout = () => {
    const { stepsBasedOnState } = useChangeExistingPlanFlow();
    const {
        mainOwnerDetails,
        jointAccountDetails,
        productName,
    } = useChangePlan();

    const mainOwner = { name: mainOwnerDetails?.clientName, age: mainOwnerDetails?.clientAge };
    const jaClient = { name: jointAccountDetails?.clientName, age: jointAccountDetails?.clientAge };

    const footerAdditionalInfo = useMemo(() => [
        {
            label: 'portfolio.createNewPortfolio.clientName',
            values: [mainOwner?.name ?? '-', ...[jaClient?.name]],
        },
        {
            label: 'portfolio.createNewPortfolio.clientAge',
            values: [mainOwner?.age?.toString() ?? '-', ...[jaClient?.age?.toString()]],
        },
    ], [mainOwner, jaClient]);

    const {
        stepper: {
            steps: currentProcessSteps,
            title,
            currentStepNumber,
        },
        contentTitle,
        contentClassName,
        isStepperEnabled,
        isFooterSimplified,
        onContinue,
        onBack,
        continueDisabled,
        isContinueLoading,
        backDisabled,
        hideStepperButtons,
        productType,
        pageErrors,
    } = useRouteBasedStepperLayout({
        title: 'Change existing plan',
        productType: productName,
        stepsBasedOnState,
    });

    return {
        footerAdditionalInfo,
        stepper: {
            steps: currentProcessSteps,
            title,
            currentStepNumber,
        },
        onBack,
        onContinue,
        continueDisabled,
        backDisabled,
        inProgress: isContinueLoading,
        isStepperEnabled,
        isFooterSimplified,
        contentTitle,
        className: 'change-existing-plan-layout',
        contentClassName,
        hideStepperButtons,
        productType,
        startDate: null,
        minStartDate: null,
        allowJumpStep: false,
        showPercentage: true,
        pageErrors,
    };
};
